import { logger } from '@/utils/logger/logger';

/**
 * Shuts down and cleans up Pyne widget on logout
 *
 * This cleanup function removes all Pyne artifacts from the browser to prevent
 * state persistence issues when users log out and back in. Without this cleanup,
 * Pyne tours may not trigger correctly on subsequent logins because the global
 * objects and scripts remain in memory.
 *
 * Cleans up:
 * - window.pyne function
 * - window.pyneSettings object
 * - Pyne widget script from DOM
 */
export const shutDownPyne = () => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window.pyne !== 'undefined') {
      delete window.pyne;
      logger.info('Pyne function cleared from window');
    }

    if (typeof window.pyneSettings !== 'undefined') {
      delete window.pyneSettings;
      logger.info('Pyne settings cleared from window');
    }

    const pyneScript = document.getElementById('pyne-widget-script');
    if (pyneScript?.nextSibling) {
      const pyneWidgetScript = Array.from(document.querySelectorAll('script')).find(
        (script) => script.src.includes('pyne-widget.umd.js')
      );
      if (pyneWidgetScript) {
        pyneWidgetScript.remove();
        logger.info('Pyne widget script removed from DOM');
      }
    }

    logger.info('Pyne shutdown completed');
  } catch (error) {
    logger.warn('Pyne shutdown failed', { error });
  }
};
